
import { db, functions } from '@/firebase'
import XLSX from 'xlsx';
import jsPDF from 'jspdf'


import moment from 'moment-timezone'
import { restSinNegocio2 } from '@/utils/restaurantes.utils.js'
export default {
  // getEstadisticaNegocio({ rootState, state }) {
  //   const negocio = rootState.app.negocioGest;
  //   const rango = state.rango;
  //   const tipo = state.tipo;
  //   var stats = functions.httpsCallable('httpNegociosGetStats');
  //   return stats({
  //     negocio: negocio,
  //     rango: rango,
  //     tipo: tipo
  //   })
  //     .then(function (result) {
  //       return result.data;
  //     })
  //     .catch((e) => {
  //       return Promise.reject(e);
  //     })
  // },
  getEstadisticasHistorial({ state, commit, rootGetters, rootState }) {
    let r1 = moment(state.rangoHistorial.inicio).hour(state.horaInicio).toDate()
    let r2 = moment(state.rangoHistorial.fin).hour(state.horaInicio).add(1, 'days').toDate()
    const role = rootGetters['auth/role'];
    var consulta1 = db.collection('pedidos')
      //.where('negocio', '==', negocio)
      .where('estado', '==', 'finalizado')
      //.where('cobrado', '!=', false)
      .where('fechaServidor', '>', r1)
      .where('fechaServidor', '<', r2)
    var consulta2 = db.collection('pedidos')
      //.where('negocio', '==', negocio)
      .where('estado', '==', 'tpv-realizando')
      //.where('cobrado', '!=', false)
      .where('fechaServidor', '>', r1)
      .where('fechaServidor', '<', r2)


    if (role == 'boss_negocio') {
      consulta1 = consulta1.where('negocio', '==', rootState.app.negocioGest)
      consulta2 = consulta2.where('negocio', '==', rootState.app.negocioGest)
    } else if (role == 'boss_restaurante') {
      consulta1 = consulta1.where('restaurante', '==', restSinNegocio2(rootState.app.restauranteGest[0], rootState.app.negocioGest))
      consulta2 = consulta2.where('restaurante', '==', restSinNegocio2(rootState.app.restauranteGest[0], rootState.app.negocioGest))
    } else if (role == 'boss_directorio') {
      consulta1 = consulta1.where('directorio', '==', rootState.app.directorioGest)
      consulta2 = consulta2.where('directorio', '==', rootState.app.directorioGest)
    }

    return Promise.all([
      consulta1
        .orderBy('fechaServidor', 'desc')
        .get(),
      consulta2
        .orderBy('fechaServidor', 'desc')
        .get()
    ])
      .then((r) => {

        var pedidos = [];
        pedidos =
          [
            ...r[0].docs.map(p => {
              const data = p.data();
              const tz = (data.copyRest.confGeneral && data.copyRest.confGeneral.zonaHoraria) ? data.copyRest.confGeneral.zonaHoraria : 'Europe/Madrid';
              return {
                ...data,
                fechaMostrar: moment(data.fechaServidor.toDate()).tz(tz).format('YYYY-MM-DD HH:mm'),
                id: p.id
              }
            }),
            ...r[1].docs.map(p => {
              const data = p.data();
              const tz = (data.copyRest.confGeneral && data.copyRest.confGeneral.zonaHoraria) ? data.copyRest.confGeneral.zonaHoraria : 'Europe/Madrid';
              return {
                ...data,
                fechaMostrar: moment(data.fechaServidor.toDate()).tz(tz).format('YYYY-MM-DD HH:mm'),
                id: p.id
              }
            })
          ]
        commit('setPedidosHistorial', pedidos);




      })
  },
  exportarCSV({ }, pedidos) {
    console.log(pedidos);
    let csvContent = "data:text/csv;charset=utf-8,"
      + "Numero Pedido,Fecha,Modo,Forma Pago,Cantidad,Eliminado,Restaurante\n"
      + pedidos.map(e => {
        let aux = {
          id: e.numPedidoRest,
          fecha: moment.unix(e.fechaServidor.seconds).tz('Europe/Madrid').format('HH:mm DD-MM-YYYY'),
          modo: e.modo,
          pago: e.formaPago,
          precio: e.precioTotal,
          eliminado: e.eliminado ? 'SI' : 'NO',
          rest: e.copyNegocio.nombre + ' - ' + e.copyRest.nombre
        }
        return Object.values(aux).join(",")
      }).join("\n");
    return (csvContent);
  },
  //bigquery
  getEstadisticasBQ({ state, rootState, commit, rootGetters }, { filtros }) {
    var stats = functions.httpsCallable('httpBqGetStats');
    console.log(filtros);
    if (rootGetters['app/esDesarrollo']) {
      const datosDesarrollo = [
        [
          {
            "NUM_PEDIDOS": 6888,
            "TOTAL": 181717.19999999827,
            "DIA_SEMANA": 1
          },
          {
            "NUM_PEDIDOS": 2400,
            "TOTAL": 57535.76000000008,
            "DIA_SEMANA": 2
          },
          {
            "NUM_PEDIDOS": 2361,
            "TOTAL": 56834.63000000007,
            "DIA_SEMANA": 3
          },
          {
            "NUM_PEDIDOS": 2717,
            "TOTAL": 67214.86000000019,
            "DIA_SEMANA": 4
          },
          {
            "NUM_PEDIDOS": 2958,
            "TOTAL": 76004.00000000017,
            "DIA_SEMANA": 5
          },
          {
            "NUM_PEDIDOS": 5928,
            "TOTAL": 158538.3199999986,
            "DIA_SEMANA": 6
          },
          {
            "NUM_PEDIDOS": 6884,
            "TOTAL": 185201.26999999952,
            "DIA_SEMANA": 7
          }
        ],
        [
          {
            "NUM_PEDIDOS": 1574,
            "TOTAL": 36101.980000000076,
            "HORA": {
              "value": "22:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 4826,
            "TOTAL": 123598.49999999977,
            "HORA": {
              "value": "14:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 6738,
            "TOTAL": 162355.05999999883,
            "HORA": {
              "value": "21:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 7153,
            "TOTAL": 190770.89999999825,
            "HORA": {
              "value": "20:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 288,
            "TOTAL": 7609.180000000002,
            "HORA": {
              "value": "16:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 5026,
            "TOTAL": 134833.19999999966,
            "HORA": {
              "value": "13:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 1587,
            "TOTAL": 50123.709999999985,
            "HORA": {
              "value": "19:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 1636,
            "TOTAL": 39137.82000000012,
            "HORA": {
              "value": "15:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 45,
            "TOTAL": 981.1999999999997,
            "HORA": {
              "value": "23:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 593,
            "TOTAL": 15196.849999999991,
            "HORA": {
              "value": "12:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 433,
            "TOTAL": 15079.339999999986,
            "HORA": {
              "value": "18:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 236,
            "TOTAL": 7255.6200000000035,
            "HORA": {
              "value": "17:00:00"
            }
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 2.68,
            "HORA": {
              "value": "08:00:00"
            }
          }
        ],
        [
          {
            "NUM_PEDIDOS": 472,
            "TOTAL": 14063.629999999972,
            "RESTAURANTE": "padthaiwok-ibiza"
          },
          {
            "NUM_PEDIDOS": 1479,
            "TOTAL": 32257.99999999999,
            "RESTAURANTE": "padthaiwok-granada-pza-fortuny"
          },
          {
            "NUM_PEDIDOS": 1133,
            "TOTAL": 25800.870000000014,
            "RESTAURANTE": "padthaiwok-motril"
          },
          {
            "NUM_PEDIDOS": 1826,
            "TOTAL": 42499.42000000009,
            "RESTAURANTE": "padthaiwok-fuengirola"
          },
          {
            "NUM_PEDIDOS": 540,
            "TOTAL": 20781.08999999998,
            "RESTAURANTE": "makati-fuengirola"
          },
          {
            "NUM_PEDIDOS": 751,
            "TOTAL": 17305.490000000034,
            "RESTAURANTE": "padthaiwok-murcia"
          },
          {
            "NUM_PEDIDOS": 486,
            "TOTAL": 12491.249999999987,
            "RESTAURANTE": "padthaiwok-lopez-de-hoyos"
          },
          {
            "NUM_PEDIDOS": 944,
            "TOTAL": 21296.619999999995,
            "RESTAURANTE": "padthaiwok-arroyo-de-la-miel"
          },
          {
            "NUM_PEDIDOS": 789,
            "TOTAL": 18999.639999999967,
            "RESTAURANTE": "padthaiwok-cc-nevada"
          },
          {
            "NUM_PEDIDOS": 346,
            "TOTAL": 15978.299999999996,
            "RESTAURANTE": "da-bruno-a-casa"
          },
          {
            "NUM_PEDIDOS": 380,
            "TOTAL": 29581.25,
            "RESTAURANTE": "sky-sushi-aravaca"
          },
          {
            "NUM_PEDIDOS": 9,
            "TOTAL": 228.90000000000003,
            "RESTAURANTE": "padthaiwok-magaluf"
          },
          {
            "NUM_PEDIDOS": 798,
            "TOTAL": 17528.69999999998,
            "RESTAURANTE": "padthaiwok-malaga-pza-solidaridad"
          },
          {
            "NUM_PEDIDOS": 613,
            "TOTAL": 13683.51999999998,
            "RESTAURANTE": "padthaiwok-valencia"
          },
          {
            "NUM_PEDIDOS": 868,
            "TOTAL": 21275.599999999988,
            "RESTAURANTE": "padthaiwok-cc-torrecardenas"
          },
          {
            "NUM_PEDIDOS": 715,
            "TOTAL": 15427.100000000017,
            "RESTAURANTE": "padthaiwok-sevilla"
          },
          {
            "NUM_PEDIDOS": 412,
            "TOTAL": 10526.189999999984,
            "RESTAURANTE": "padthaiwok-estepona"
          },
          {
            "NUM_PEDIDOS": 205,
            "TOTAL": 5819.409999999998,
            "RESTAURANTE": "padthaiwok-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 1029,
            "TOTAL": 26887.200000000055,
            "RESTAURANTE": "nomadas-burguer-teatinos"
          },
          {
            "NUM_PEDIDOS": 1001,
            "TOTAL": 26048.60000000001,
            "RESTAURANTE": "padthaiwok-alhaurin-de-la-torre"
          },
          {
            "NUM_PEDIDOS": 268,
            "TOTAL": 11518.599999999995,
            "RESTAURANTE": "da-bruno-san-pedro"
          },
          {
            "NUM_PEDIDOS": 463,
            "TOTAL": 11586.209999999988,
            "RESTAURANTE": "padthaiwok-mallorca"
          },
          {
            "NUM_PEDIDOS": 1524,
            "TOTAL": 40134.170000000064,
            "RESTAURANTE": "padthaiwok-san-sebastian"
          },
          {
            "NUM_PEDIDOS": 831,
            "TOTAL": 19802.550000000003,
            "RESTAURANTE": "padthaiwok-torre-del-mar"
          },
          {
            "NUM_PEDIDOS": 227,
            "TOTAL": 5717.369999999996,
            "RESTAURANTE": "padthaiwok-cartegena"
          },
          {
            "NUM_PEDIDOS": 1575,
            "TOTAL": 40590.500000000386,
            "RESTAURANTE": "nomadas-burguer-santa-paula"
          },
          {
            "NUM_PEDIDOS": 1066,
            "TOTAL": 24319.960000000014,
            "RESTAURANTE": "padthaiwok-teatinos"
          },
          {
            "NUM_PEDIDOS": 1419,
            "TOTAL": 30076.669999999995,
            "RESTAURANTE": "padthaiwok-pza-einstein"
          },
          {
            "NUM_PEDIDOS": 1029,
            "TOTAL": 25599.050000000025,
            "RESTAURANTE": "padthaiwok-la-latina"
          },
          {
            "NUM_PEDIDOS": 200,
            "TOTAL": 4636.950000000002,
            "RESTAURANTE": "padthaiwok-la-cala-de-mijas"
          },
          {
            "NUM_PEDIDOS": 135,
            "TOTAL": 9824,
            "RESTAURANTE": "sky-sushi-recoletos"
          },
          {
            "NUM_PEDIDOS": 242,
            "TOTAL": 5104.370000000001,
            "RESTAURANTE": "padthaiwok-las-palmas-de-gran-canarias"
          },
          {
            "NUM_PEDIDOS": 274,
            "TOTAL": 11788.499999999995,
            "RESTAURANTE": "da-bruno-sul-mare"
          },
          {
            "NUM_PEDIDOS": 148,
            "TOTAL": 2896.1999999999985,
            "RESTAURANTE": "barrio-pinto-cruz-de-humilladero"
          },
          {
            "NUM_PEDIDOS": 7,
            "TOTAL": 199.25,
            "RESTAURANTE": "suki-sushi-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 135,
            "TOTAL": 8448,
            "RESTAURANTE": "sky-sushi-boadilla"
          },
          {
            "NUM_PEDIDOS": 841,
            "TOTAL": 17009.92999999995,
            "RESTAURANTE": "pizza-mania-fuengirola"
          },
          {
            "NUM_PEDIDOS": 477,
            "TOTAL": 9972.50000000001,
            "RESTAURANTE": "barrio-pinto-churriana"
          },
          {
            "NUM_PEDIDOS": 906,
            "TOTAL": 21560.179999999997,
            "RESTAURANTE": "padthaiwok-marbella"
          },
          {
            "NUM_PEDIDOS": 581,
            "TOTAL": 12216.720000000007,
            "RESTAURANTE": "padthaiwok-santa-paula"
          },
          {
            "NUM_PEDIDOS": 6,
            "TOTAL": 153.6,
            "RESTAURANTE": "el-club-empanadas-argentinas-malaga"
          },
          {
            "NUM_PEDIDOS": 533,
            "TOTAL": 13325.999999999996,
            "RESTAURANTE": "padthaiwok-rincon-de-la-victoria"
          },
          {
            "NUM_PEDIDOS": 94,
            "TOTAL": 1536.0099999999998,
            "RESTAURANTE": "ditos-pizza-fuengirola"
          },
          {
            "NUM_PEDIDOS": 139,
            "TOTAL": 3155.5499999999993,
            "RESTAURANTE": "los-bandios-granada"
          },
          {
            "NUM_PEDIDOS": 875,
            "TOTAL": 21179.239999999994,
            "RESTAURANTE": "padthaiwok-mallorca-pza-espana"
          },
          {
            "NUM_PEDIDOS": 59,
            "TOTAL": 1321.1000000000006,
            "RESTAURANTE": "la-scala-malaga"
          },
          {
            "NUM_PEDIDOS": 71,
            "TOTAL": 1882.3999999999994,
            "RESTAURANTE": "padthaiwok-fuengirola-miramar"
          },
          {
            "NUM_PEDIDOS": 356,
            "TOTAL": 8043.600000000006,
            "RESTAURANTE": "padthaiwok-cc-torre-outlet"
          },
          {
            "NUM_PEDIDOS": 38,
            "TOTAL": 3314.5,
            "RESTAURANTE": "sky-sushi-pozuelo"
          },
          {
            "NUM_PEDIDOS": 350,
            "TOTAL": 14850.599999999993,
            "RESTAURANTE": "da-bruno-cabopino"
          },
          {
            "NUM_PEDIDOS": 56,
            "TOTAL": 1662.6900000000003,
            "RESTAURANTE": "padthaiwok-cc-mogan"
          },
          {
            "NUM_PEDIDOS": 22,
            "TOTAL": 620.9999999999999,
            "RESTAURANTE": "padthaiwok-sierra-nevada"
          },
          {
            "NUM_PEDIDOS": 198,
            "TOTAL": 5165.200000000003,
            "RESTAURANTE": "padthaiwok-mallorca-santa-catalina"
          },
          {
            "NUM_PEDIDOS": 11,
            "TOTAL": 317.4,
            "RESTAURANTE": "la-chelinda-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 49,
            "TOTAL": 2017.7500000000005,
            "RESTAURANTE": "tommy-mels-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 40,
            "TOTAL": 791.9000000000001,
            "RESTAURANTE": "padthaiwok-la-canada"
          },
          {
            "NUM_PEDIDOS": 8,
            "TOTAL": 119.19999999999999,
            "RESTAURANTE": "pizza-hi-fuengirola"
          },
          {
            "NUM_PEDIDOS": 2,
            "TOTAL": 28,
            "RESTAURANTE": "dunkin-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 8,
            "TOTAL": 232.70000000000005,
            "RESTAURANTE": "demo-malaga"
          },
          {
            "NUM_PEDIDOS": 10,
            "TOTAL": 140.4,
            "RESTAURANTE": "padthaiwok-plaza-mayor"
          },
          {
            "NUM_PEDIDOS": 37,
            "TOTAL": 798.37,
            "RESTAURANTE": "padthaiwok-cc-el-ingenio"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 45.8,
            "RESTAURANTE": "yankee-burgers-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 2,
            "TOTAL": 140.1,
            "RESTAURANTE": "burrito-wey-cc-nueva-condomina"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 43.5,
            "RESTAURANTE": "el-pikoteo-la-cala-de-mijas"
          },
          {
            "NUM_PEDIDOS": 20,
            "TOTAL": 537.0999999999999,
            "RESTAURANTE": "pizzeria-bicocca-marbella"
          },
          {
            "NUM_PEDIDOS": 3,
            "TOTAL": 109.05000000000001,
            "RESTAURANTE": "demo-restaurante-sevilla"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 8,
            "RESTAURANTE": "mama-me-lo-como-todo-alicante"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 17.5,
            "RESTAURANTE": "demo-restaurante-granada"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 5.32,
            "RESTAURANTE": "demo-sevilla"
          }
        ],
        [
          {
            "NUM_PEDIDOS": 23187,
            "TOTAL": 549617.9400000037,
            "NEGOCIO": "padthaiwok"
          },
          {
            "NUM_PEDIDOS": 540,
            "TOTAL": 20781.08999999998,
            "NEGOCIO": "makati"
          },
          {
            "NUM_PEDIDOS": 1238,
            "TOTAL": 54136.0000000001,
            "NEGOCIO": "da-bruno"
          },
          {
            "NUM_PEDIDOS": 688,
            "TOTAL": 51167.75,
            "NEGOCIO": "sky-sushi"
          },
          {
            "NUM_PEDIDOS": 2604,
            "TOTAL": 67477.70000000096,
            "NEGOCIO": "nomadas-burguer"
          },
          {
            "NUM_PEDIDOS": 625,
            "TOTAL": 12868.700000000006,
            "NEGOCIO": "barrio-pinto"
          },
          {
            "NUM_PEDIDOS": 7,
            "TOTAL": 199.25,
            "NEGOCIO": "suki-sushi"
          },
          {
            "NUM_PEDIDOS": 841,
            "TOTAL": 17009.92999999995,
            "NEGOCIO": "pizza-mania"
          },
          {
            "NUM_PEDIDOS": 6,
            "TOTAL": 153.6,
            "NEGOCIO": "el-club-empanadas-argentinas"
          },
          {
            "NUM_PEDIDOS": 94,
            "TOTAL": 1536.0099999999998,
            "NEGOCIO": "ditos-pizza"
          },
          {
            "NUM_PEDIDOS": 139,
            "TOTAL": 3155.5499999999993,
            "NEGOCIO": "los-bandios"
          },
          {
            "NUM_PEDIDOS": 59,
            "TOTAL": 1321.1000000000006,
            "NEGOCIO": "la-scala"
          },
          {
            "NUM_PEDIDOS": 11,
            "TOTAL": 317.4,
            "NEGOCIO": "la-chelinda"
          },
          {
            "NUM_PEDIDOS": 49,
            "TOTAL": 2017.7500000000005,
            "NEGOCIO": "tommy-mels"
          },
          {
            "NUM_PEDIDOS": 8,
            "TOTAL": 119.19999999999999,
            "NEGOCIO": "pizza-hi"
          },
          {
            "NUM_PEDIDOS": 2,
            "TOTAL": 28,
            "NEGOCIO": "dunkin"
          },
          {
            "NUM_PEDIDOS": 9,
            "TOTAL": 238.02000000000004,
            "NEGOCIO": "demo"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 45.8,
            "NEGOCIO": "yankee-burgers"
          },
          {
            "NUM_PEDIDOS": 2,
            "TOTAL": 140.1,
            "NEGOCIO": "burrito-wey"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 43.5,
            "NEGOCIO": "el-pikoteo"
          },
          {
            "NUM_PEDIDOS": 20,
            "TOTAL": 537.0999999999999,
            "NEGOCIO": "pizzeria-bicocca"
          },
          {
            "NUM_PEDIDOS": 4,
            "TOTAL": 126.55000000000001,
            "NEGOCIO": "demo-restaurante"
          },
          {
            "NUM_PEDIDOS": 1,
            "TOTAL": 8,
            "NEGOCIO": "mama-me-lo-como-todo"
          }
        ],
        [
          {
            "NUM_PEDIDOS": 24270,
            "TOTAL": 641534.7000000168,
            "MODO": "domicilio"
          },
          {
            "NUM_PEDIDOS": 5866,
            "TOTAL": 141511.3399999997,
            "MODO": "recoger"
          }
        ],
        [
          {
            "NUM_PEDIDOS": 10603,
            "TOTAL": 284561.77999999793,
            "FORMA_PAGO": "tarjeta_online"
          },
          {
            "NUM_PEDIDOS": 8546,
            "TOTAL": 228694.94999999768,
            "FORMA_PAGO": "tarjeta_domicilio"
          },
          {
            "NUM_PEDIDOS": 4271,
            "TOTAL": 100570.77000000003,
            "FORMA_PAGO": "local"
          },
          {
            "NUM_PEDIDOS": 6701,
            "TOTAL": 168648.6899999986,
            "FORMA_PAGO": "efectivo"
          },
          {
            "NUM_PEDIDOS": 15,
            "TOTAL": 569.85,
            "FORMA_PAGO": "tarjeta_online_multiple"
          }
        ],
        [
          {
            "NUM_PEDIDOS": 30136,
            "TOTAL": 783046.0400000315
          }
        ]
      ]
      commit('setPedidos', datosDesarrollo)
    } else {
      let horaInicioComparar = moment.tz(state.rangoComparar.inicio, 'YYYY-MM-DD', 'Europe/Madrid').hour(rootState.horaInicio).unix();
      let horaFinComparar = moment.tz(state.rangoComparar.fin, 'YYYY-MM-DD', 'Europe/Madrid').hour(rootState.horaInicio).unix();
      let datos = {
        inicio: moment.tz(state.rango.inicio, 'YYYY-MM-DD', 'Europe/Madrid').hour(rootState.horaInicio).unix(),
        fin: moment.tz(state.rango.fin, 'YYYY-MM-DD', 'Europe/Madrid').hour(rootState.horaInicio).add(1, 'day').unix(),
        inicioComparar: isNaN(horaInicioComparar) ? null : horaInicioComparar,
        finComparar: isNaN(horaFinComparar) ? null : horaFinComparar,
        filtros: filtros
      };
      console.log(datos);
      return stats(datos)
        .then(r => {
          console.log(r.data);
          if (r.data.ok) {
            commit('setPedidos', r.data.datos.actual)
            commit('setPedidosComparar', r.data.datos.comparar)
          } else {
            return Promise.reject(r.data.error)
          }
        })
    }

  },
  exportarExcelBQ({ }, datos) {
    var exportar = functions.httpsCallable('httpBqExportarExcel');
    return exportar(datos)
      .then(r => {
        console.log(r)
        return r.data;
        // return r.data;
        return new Blob([r.data]);
        return r.data;
      })
  },
  exportarExcelBQ_deprecated({ rootState, state }, datos) {
    console.log(datos);

    const workbook = XLSX.utils.book_new();
    var inicio = moment.tz(state.rango.inicio, 'YYYY-MM-DD', 'Europe/Madrid').hour(rootState.horaInicio).unix();
    var fin = moment.tz(state.rango.fin, 'YYYY-MM-DD', 'Europe/Madrid').hour(rootState.horaInicio).add(1, 'day').unix();

    var ws = XLSX.utils.aoa_to_sheet([])
    XLSX.utils.sheet_add_aoa(ws, [
      ['INICIO', 'FIN'],
      [state.rango.inicio, state.rango.fin],
    ], { origin: 'B1' });

    XLSX.utils.sheet_add_aoa(ws, [
      ['PEDIDOS TOTAL', 'FACTURACIÓN TOTAL'],
      [datos.pedidos.NUM_PEDIDOS, datos.pedidos.TOTAL],
    ], { origin: 'B4' });

    //DIA SEMANA
    var diaSemana = (i) => {
      switch (i) {
        case 1: return 'LUNES';
        case 2: return 'MARTES';
        case 3: return 'MIERCOLES';
        case 4: return 'JUEVES';
        case 5: return 'VIERNES';
        case 6: return 'SABADO';
        case 7: return 'DOMINGO';
      }
    }
    XLSX.utils.sheet_add_aoa(ws, [
      ['DIA', 'PEDIDOS', 'FACTURACIÓN'],
      ...datos.diasSemana.map(d => [diaSemana(d.diaSemana), d.numPedidos, d.total])
    ], { origin: 'A7' });

    //MODO
    XLSX.utils.sheet_add_aoa(ws, [
      ['MODO', 'PEDIDOS', 'FACTURACIÓN'],
      ...datos.modo.map(d => [d.modo.toUpperCase(), d.numPedidos, d.total])
    ], { origin: 'A16' });

    //FORMA PAGO
    XLSX.utils.sheet_add_aoa(ws, [
      ['FORMA PAGO', 'PEDIDOS', 'FACTURACIÓN'],
      ...datos.formaPago.map(d => [d.modo.toUpperCase(), d.numPedidos, d.total])
    ], { origin: 'A20' });



    var wscols = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];

    ws['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workbook, ws, 'PEDIDOS')

    const filename = rootState.app.negocioGest;
    XLSX.writeFile(workbook, state.rango.inicio + ' ' + state.rango.fin + ' ' + 'stats.xlsx');

    return { ok: true }



  }
}